const encoder = new TextEncoder();

export function formatTlvLength(value: string): string {
  const byteLength = encoder.encode(value).length;
  if (byteLength > 99) {
    throw new Error('TLV value is too long');
  }
  return byteLength.toString().padStart(2, '0');
}

export function tlv(tag: string, value: string): string {
  if (!/^\d{2}$/.test(tag)) {
    throw new Error(`Invalid TLV tag: ${tag}`);
  }
  return `${tag}${formatTlvLength(value)}${value}`;
}

export function nestedTlv(tag: string, children: readonly string[]): string {
  return tlv(tag, children.join(''));
}
